<template>
  <UDrawer
    v-model:open="investigateOpen"
    direction="right"
    :handle="false"
    title="Investigate Code"
    description="Validate point codes, review usage, and flag suspicious activity."
    :ui="drawerUi"
  >
    <template #body>
      <PointshopPointCodeInvestigation />
    </template>
  </UDrawer>

  <UDrawer
    v-model:open="generateOpen"
    direction="right"
    :handle="false"
    title="Generate Point Codes"
    description="Choose a pointshop campaign and generate codes."
    :ui="drawerUi"
  >
    <template #body>
      <PointshopPointCodeGenerator />
    </template>
  </UDrawer>

  <UDrawer
    v-model:open="reportOpen"
    direction="right"
    :handle="false"
    title="Report Suspicious Code"
    description="Find a customer, then log the suspicious code."
    :ui="reportDrawerUi"
  >
    <template #body>
      <PointshopReportSuspiciousCode />
    </template>
  </UDrawer>
</template>

<script lang="ts" setup>
/** Matches `action` on Point Codes items in menuLinksMainMenu. */
const menuAction = useState<string | null>('menuAction', () => null)

const drawerUi = {
  content: 'w-[min(100vw,32rem)] sm:w-[min(100vw-1rem,36rem)] max-w-none min-w-0 h-full min-h-0',
  container: 'flex h-full min-h-0 max-h-[100dvh] flex-1 flex-col gap-0 p-0 overflow-hidden',
  header: 'shrink-0 border-b border-gray-200 px-4 pt-4 pb-3 dark:border-gray-800 sm:px-5',
  body: 'flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto px-4 py-4 sm:px-5',
} as Record<string, string>

const reportDrawerUi = {
  ...drawerUi,
  content: 'w-[min(100vw,36rem)] sm:w-[min(100vw-1rem,40rem)] max-w-none min-w-0 h-full min-h-0',
} as Record<string, string>

function drawer(action: string) {
  return computed({
    get: () => menuAction.value === action,
    set: (open: boolean) => {
      if (!open && menuAction.value === action) menuAction.value = null
    },
  })
}

const investigateOpen = drawer('investigate')
const generateOpen = drawer('generate')
const reportOpen = drawer('report')
</script>
